export default "__VITE_ASSET__DiYZwuGX__"